import React from "react";
import moment from "moment";
import { withRouter } from "react-router-dom";
import defaultLogoUrl from "styles/img/no-cert-sign.png";
import locationImg from "styles/img/location.svg";
import uploadImg from "styles/img/upload-csv.svg";

@withRouter
export default class MyRegularWS_Panel extends React.Component {
  getStartDate = () => {
    const { workshop } = this.props;
    return [
      moment(workshop.start_date).format("DD MMM 'YY"),
      moment(workshop.start_time).format("HH:mm")
    ].join(" ");
  };

  goToEdit = () => {
    const {history, workshop} = this.props;
    history.push(`/createorganization/${workshop.id}`);
  }

  render() {
    const { showModal, workshop, loadAttachment, loadCsv } = this.props;

    return (
      <div className="col-12 col-md-3 my-regular-panel">
        <div className="attendee-panel-wrapper">
          <div>
            <p className="ws-title">{workshop.title}</p>
            <span className="ws-date">{this.getStartDate()}</span>
            <img className="location-icon" src={locationImg} alt="loc" />
            <span className="ws-location">{workshop.venue_county}</span>
          </div>
          <div className="panel-in-the-middle">
            <p>CPD Cert Template</p>
            <p>
              If you wish, you can upload a logo and your e-signature to
              customise your CPD cert. This is not mandatory
            </p>
            <div className="wrapper-logo-signature">
              <div className="logo-block">
                <div className="img-container">
                  <input
                    type="file"
                    onChange={e => loadAttachment(e, "logo")}
                  />
                  <img src={workshop.logo_url || defaultLogoUrl} alt="no-img" />
                </div>
                <span>LOGO</span>
              </div>
              <div className="sign-block">
                <div className="img-container">
                  <input
                    type="file"
                    onChange={e => loadAttachment(e, "signature")}
                  />
                  <img
                    src={workshop.signature_url || defaultLogoUrl}
                    alt="no-img"
                  />
                </div>
                <span>E-SIGNATURE</span>
              </div>
            </div>
          </div>
          <div className="panel-at-the-bottom">
            <button className="btn-prime-blue" onClick={e => showModal(e)}>
              ADD ATTENDEE
            </button>
            <div className="attendee-csv-wrapper">
              <input type="file" onChange={e => loadCsv(e)} />
              <img src={uploadImg} alt="upload" />
              <span className="upload-csv-label">
                upload attendees list CSV file
              </span>
            </div>
            <p className="upload-csv-infotext">
              The first row of the CSV file must contain the following column
              titles exactly as specified: first name, last name, email address.
            </p>
            {workshop.workshop_type === 'organization' ?
              <button className="btn-prime-blue" onClick={this.goToEdit}>
                EDIT
              </button> : null
            }
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/myRegularWorkshop/MyRegularWS_Panel.jsx